<template>
  <v-row no-gutters>
    <v-col class="pr-6 pl-12 white" :md="12" :xl="resourceViewer.show && resourceViewer.width > 0 ? 12 : 9" offset-lg="0" :offset-xl="resourceViewer.show && resourceViewer.width > 0  ? 0 : 1" offset-md="0">
      <!-- <context-page v-if="isContextPage"></context-page> -->
      <research-page v-if="isResourcesPage"></research-page>
      <!-- <section-page
        v-else-if="isSectionPage"
        :sectionId="selectedPageId.split('-')[1]"
      ></section-page> -->
      <note-page v-else></note-page>
    </v-col>
  </v-row>
</template>

<script>
import SectionPage from './SectionPage';
import ContextPage from './ContextPage';
import ResearchPage from './ResearchPage';
import NotePage from './NotePage';

import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';

export default {
  components: {
    SectionPage,
    ContextPage,
    ResearchPage,
    NotePage
  },
  props: {
    selectedNote: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      slowLoad: true,
      dragSelecting: false,
      selectedNoteBlocks: [],
      hiddenNoteBlocks: []
    };
  },
  destroyed() {
    document.removeEventListener('keypress', this.copyTrigger);
  },
  computed: {
    ...mapState('views/context', [
      'selectedPageId',
      'focusTo',
      'showResourcePanel',
      'resourceViewer'
    ]),
    ...mapState('pages', ['pages']),
    ...mapGetters('components/dragdrop', ['dragging']),
    ...mapGetters('context', ['questions', 'userCanEdit']),
    ...mapGetters('pages', ['selectedPageNotes']),
    ...mapState('components/notepad', ['clipboard']),
    isSectionPage() {
      return this.selectedPageId.split('-')[0] == 'section';
    },
    isContextPage() {
      return !this.selectedPageId;
    },
    isResourcesPage() {
      return this.selectedPageId == 'resources';
    }
  },
  watch: {
    // focusTo: function(n) {
    //   //  if we are going from false to true focus
    //   if (n == 'page') {
    //     console.log('focus to list item');
    //     const lastNote = this.selectedPageNotes[this.selectedPageNotes.length - 1];
    //     this.focusNoteBlock({ noteId: lastNote.id });
    //   }
    // },
    // selectedPageId: function() {
    //   //  Reset selectedNoteBlocks
    //   this.selectedNoteBlocks = [];
    //   //  Give us a second to load everything slowly, after that load new things load instanlty
    //   this.slowLoad = true;
    //   setTimeout(() => (this.slowLoad = false), 2000);
    // },
    // selectedNoteBlocks: function(newValue, oldValue) {
    //   if (newValue.length > 0 && oldValue.length == 0) {
    //     //  we started drag
    //     console.log('add copy event listener');
    //     document.addEventListener('keydown', this.selectBlockHotKeys);
    //   } else if (newValue.length == 0 && oldValue.length > 0) {
    //     console.log('remove copy event listener');
    //     document.removeEventListener('keydown', this.selectBlockHotKeys);
    //   }
    // }
  },
  methods: {
    ...mapActions('pages', ['removeNoteBlock', 'addNoteBlock']),
    ...mapMutations('views/context', ['setFocusTo']),
    ...mapMutations('components/notepad', ['setClipboard']),
    ...mapMutations('components/dragdrop', ['setDragPosition', 'updateDraggedData']),
    log(x) {
      console.log(x);
    }
    // selectBlockHotKeys(event) {
    //   const key = event.which || event.keyCode;
    //   console.log(event);
    //   if (key == 67 && event.ctrlKey) {
    //     this.copyBlocks();
    //   }
    //   if (key == 46 || key == 8) {
    //     //  handle delete
    //     this.deleteSelectedBlocks();
    //   }
    // },
    // copyBlocks() {
    //   console.log('copy blocks');
    //   const blockIds = this.selectedNoteBlocks;
    //   let text = '';
    //   let contents = [];
    //   let blocks = blockIds.map(id => this.selectedPageNotes.find(n => n.id == id));

    //   blocks = blocks.sort((a, b) => a.order - b.order);
    //   blocks.forEach(b => {
    //     text += this.$refs[b.id][0].$refs.editor.editor.getText();
    //     contents.push(b.content);
    //   });
    //   this.setClipboard({
    //     text,
    //     blockIds,
    //     contents,
    //     parent: this.selectedPageId
    //   });
    //   this.$copyText(text);
    // },
    // copyQuestions(copyContent) {
    //   console.log('copy blocks');
    //   let blocks;
    //   if (copyContent) {
    //     blocks = this.selectedPageNotes;
    //   } else {
    //     blocks = this.selectedPageNotes.filter(n => n.content && n.content.noteType == 'question');
    //   }

    //   let text = '';
    //   let contents = [];
    //   const blockIds = blocks.map(b => b.id);
    //   //blocks = blocks.sort((a, b) => a.order - b.order);
    //   blocks.forEach(b => {
    //     // text += this.$refs[b.id][0].$refs.editor.editor.getText();
    //     contents.push(b.content);
    //   });
    //   this.setClipboard({
    //     text,
    //     blockIds,
    //     contents,
    //     parent: this.selectedPageId
    //   });
    //   this.$copyText(text);
    // },
    // pasteQuestions() {
    //   //  using contents and parent here for future use when copying resources
    //   const { contents, parent } = this.clipboard;
    //   try {
    //     //  we are pasting our copied blocks
    //     console.log('paste note blocks');
    //     const length = this.selectedPageNotes.length;
    //     contents.forEach((n, i) => {
    //       const { html, widgetType, widgetData, noteType } = n;
    //       this.addNoteBlock({
    //         html,
    //         widgetInfo: { widgetType, widgetData },
    //         noteType,
    //         order: length + i,
    //         pageId: this.selectedPageId
    //       });
    //     });
    //   } catch (e) {
    //     return true;
    //   }
    // },
    // deleteSelectedBlocks() {
    //   const blockIds = this.selectedNoteBlocks;
    //   blockIds.forEach(b => {
    //     this.removeNoteBlock({ noteBlockId: b, pageId: this.selectedPageId });
    //   });
    // },
    // startDragSelect(e, noteId) {
    //   this.dragSelecting = true;
    //   this.selectedNoteBlocks = [noteId];
    //   this.$refs.dragSelect.onMouseDown(e);
    // },
    // toggleSelection(note) {
    //   //  check if the note we entered is already selected
    //   console.log(note.id);
    //   const selected = this.selectedNoteBlocks.includes(note.id);
    //   if (selected) {
    //     console.log('remove ', note.order);
    //     //  Already selected, we are going back and should deselect the previous one
    //     if (this.selectedNoteBlocks[this.selectedNoteBlocks.length - 1] != note.id) {
    //       this.selectedNoteBlocks.pop();
    //     }
    //   } else {
    //     console.log('add ', note.order);
    //     //  Add this one to selected
    //     this.selectedNoteBlocks.push(note.id);
    //   }
    // },
    // clearDragSelection() {
    //   this.selectedNoteBlocks = [];
    // },
    // async addNewLine({ order, delta, noteType = null }) {
    //   //  update order of all higher up notes
    //   //  new vuex note here, returns id
    //   const newId = await this.addNoteBlock({
    //     html: '',
    //     order: order,
    //     pageId: this.selectedPageId,
    //     noteType
    //   });

    //   this.$nextTick(() => {
    //     if (delta) {
    //       this.setNoteContent({ noteId: newId, delta: false });
    //     }
    //     this.$refs[newId][0].focusTitle();
    //   });
    // },
    // tab() {
    //   this.setFocusTo('listItem' + this.selectedPageId);
    // },
    // setNoteContent({ noteId, delta }) {
    //   this.$refs[noteId][0].$refs.editor.editor.setContents(delta);
    // },
    // moveToLine({ toIndex, dir }) {
    //   const to = this.selectedPageNotes.find(n => n.order == toIndex);
    //   if (to) {
    //     const toRef = this.$refs[to.id][0];
    //     const index = dir == 'next' ? 1 : toRef.$refs.editor.editor.getLength();
    //     toRef.$refs.editor.editor.setSelection(index);
    //   }
    // },
    // deleteCard({ cardId }) {
    //   // if (this.notesByCard.length > 1) {
    //   this.removeNoteBlock({ noteBlockId: cardId, pageId: this.selectedPageId });
    //   // }
    // },
    // moveLineBack({ note, delta }) {
    //   console.log(delta);
    //   const prev = this.selectedPageNotes.find(n => n.order == note.order - 1);
    //   if (prev) {
    //     if (this.$refs[prev.id][0].note.type != 'widget') {
    //       const contentEditor = this.$refs[prev.id][0].$refs.editor;
    //       const editor = contentEditor.editor;
    //       editor.setSelection(editor.getLength());
    //       if (delta) {
    //         contentEditor.updateContents(delta);
    //       }
    //     } else {
    //       this.$refs[prev.id][0].$refs.widget.$el.focus();
    //       if (delta) {
    //         //  If there is content on this line, just leave it alone
    //         return;
    //       }
    //     }
    //     //  delete note
    //     this.removeNoteBlock({ noteBlockId: note.id, pageId: this.selectedPageId });
    //   }
    // },
    // moveNextLineBack({ note }) {
    //   const next = this.selectedPageNotes.find(n => n.order == note.order + 1);
    //   if (next) {
    //     if (this.$refs[next.id][0].note.type != 'widget') {
    //       const nextDelta = this.$refs[next.id][0].$refs.editor.editor.getContents();
    //       this.$refs[note.id][0].$refs.editor.updateContents(nextDelta);
    //       this.removeNoteBlock({ noteBlockId: next.id, pageId: this.selectedPageId });
    //     } else {
    //       this.$refs[next.id][0].$refs.widget.$el.focus();
    //       if (this.$refs[note.id][0].$refs.editor.editor.getLength() == 1) {
    //         this.removeNoteBlock({ noteBlockId: note.id, pageId: this.selectedPageId });
    //       }
    //     }
    //   }
    // },
    // traverseBlocks({ toIndex, dir = 'up', event }) {
    //   console.log(toIndex);
    //   try {
    //     let targetRef = false;
    //     if (toIndex == -1) {
    //       //  go up to the question title
    //       targetRef = this.$refs.title;
    //     } else {
    //       //  get next element in list
    //       //const target = this.selectedPageNotes.find(n => n.order == toIndex);
    //       const target = this.filteredNoteBlocks[toIndex];
    //       targetRef = this.$refs[target.id][0];
    //     }
    //     if (targetRef) {
    //       if (toIndex != -1 && targetRef.note.type == 'widget') {
    //         console.log(targetRef);
    //         targetRef.$refs.widget.$el.focus();
    //       } else {
    //         //  Put the cursor in the proper position
    //         const bound = event && event.bounds ? event.bounds.left : 0;
    //         targetRef.$refs.editor.setCaret({
    //           prevLeft: bound,
    //           direction: dir
    //         });
    //       }
    //     }
    //   } catch (e) {
    //     console.log(e);
    //   }
    // },
    // setupDrag({ event, ids, element, shift }) {
    //   // get the element and shift positions for dragHelper
    //   let html = '';
    //   //  Build the html drag element
    //   let allIds = ids;
    //   if (this.selectedNoteBlocks && this.selectedNoteBlocks.includes(ids[0])) {
    //     //  Drag all the selected note blocks
    //     allIds = this.selectedNoteBlocks;
    //   }
    //   allIds.forEach(i => {
    //     html += this.$refs[i][0].$el.innerHTML;
    //   });

    //   // update drag data
    //   const dragObject = {
    //     element,
    //     shift,
    //     html,
    //     ids: allIds,
    //     types: ['noteBlock'],
    //     parent: {
    //       id: this.selectedPageId,
    //       type: 'page'
    //     }
    //   };
    //   //  first set initial drag position
    //   const { x, y } = event;
    //   this.setDragPosition({ x, y });

    //   //  now set drag content
    //   this.updateDraggedData(dragObject);
    // }
  }
};
</script>

<style>
.prompt-btn,
.prompt-btn .v-btn__content {
  justify-content: left !important;
}

@media (min-width: 1264px) {
  .notepad-sizer {
    max-width: 600px !important;
    width: 600px !important;
  }
}

@media (min-width: 1904px) {
  .notepad-sizer {
    max-width: 700px !important;
    width: 700px !important;
  }
}
</style>
